import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { CheckIcon } from '@src/shared/ui/icons';
import { Box } from '@src/shared/ui/layout';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

const SaveAllIconButton = forwardRef<
  HTMLButtonElement,
  ExtendedIconButtonProps
>((props, ref) => {
  const { t } = useTranslation();
  const {
    tooltipTitle = t('users.save_all_tooltip', 'Save All [Ctrl+S]'),
    ...buttonProps
  } = props;

  return (
    <IconButton
      ref={ref}
      {...buttonProps}
      tooltipTitle={tooltipTitle}
    >
      <Box
        sx={{
          color: props.color === 'primary' ? 'inherit' : 'error.main',
          height: 24,
          position: 'relative',
          width: 24,
        }}
      >
        <CheckIcon
          color="inherit"
          sx={{ fontSize: 18, left: 3, position: 'absolute', top: -1 }}
        />
        <CheckIcon
          color="inherit"
          sx={{ fontSize: 18, left: 3, position: 'absolute', top: 7 }}
        />
      </Box>
    </IconButton>
  );
});

SaveAllIconButton.displayName = 'SaveAllIconButton';

export default SaveAllIconButton;
